import { useElements, useStripe } from '@stripe/react-stripe-js';
import { Token } from '@stripe/stripe-js';
import { CreateTokenCardData } from '@stripe/stripe-js/types/stripe-js/token-and-sources';
import { useCallback } from 'react';

import { trackEvent } from 'utils/analytics';

type CreateTokenFn = (data: {
  additionalData: CreateTokenCardData;
}) => Promise<Token>;

export function useStripeCreateCreditCardToken(): {
  createStripeCreditCardToken: CreateTokenFn;
} {
  const stripe = useStripe();
  const elements = useElements();

  const createStripeCreditCardToken: CreateTokenFn = useCallback(
    async ({ additionalData }): Promise<Token> => {
      const { token, error } = await stripe.createToken(
        elements.getElement('cardNumber'),
        additionalData
      );

      if (token) return token;

      trackEvent('Error: Paying Card', {
        new_card: true,
        code: error.code,
        message: error.message,
      });

      throw new Error(
        (error && error.message) ||
          'Something wrong happened while creating a Stripe token for this credit card.'
      );
    },
    [stripe, elements]
  );

  return { createStripeCreditCardToken };
}
